import { render, staticRenderFns } from "./ReceiptsTab.vue?vue&type=template&id=8b1036d2"
import script from "./ReceiptsTab.vue?vue&type=script&lang=js"
export * from "./ReceiptsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports